import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface LoginState {
    userId          : string;       // 유저 ID
    pswd            : string;       // 유저 PassWord
    userIdRequired  : boolean;
    pswdRequired    : boolean;
    detail          : string; 
    loginStCd       : string;      // '':로그인 02:패스워드 03: 비밀번호 초기화
    instCd          : string; 
}
  
const initialState: LoginState = {
    userId          : '',       // 유저 ID
    pswd            : '',       // 유저 PassWord
    userIdRequired  : false,
    pswdRequired    : false,
    detail          : '',
    loginStCd       : '01',     // 01:로그인 02:패스워드 03: 비밀번호 초기화
    instCd          : '002',

}

export const loginSlice = createSlice({
    name: "login",
    initialState: initialState,
    reducers: {
        setUserId: (state, action:PayloadAction<string>) => {
            state.userId = action.payload
        },
        setPswd: (state, action:PayloadAction<string>) => {
            state.pswd = action.payload
        },
        setUserIdRequired: (state, action:PayloadAction<boolean>) => {
            state.userIdRequired = action.payload
        },
        setPswdRequired: (state, action:PayloadAction<boolean>) => {
            state.pswdRequired = action.payload
        },
        setDetail: (state, action:PayloadAction<string>) => {
            state.detail = action.payload
        },
        setLoginStCd: (state, action:PayloadAction<string>) => {
            state.loginStCd = action.payload
        },
        setInstCd: (state, action:PayloadAction<string>) => {
            state.instCd = action.payload
        },
    },
});

export default loginSlice.reducer;
export const LoginAction  = loginSlice.actions;
export const LoginReducer = loginSlice.reducer;